import {Injectable} from '@angular/core';
import {WizardState, WizardStep} from './wizard-state.model';

@Injectable()
export class WizardFlowService {

  calculePassosAtivos(state: WizardState): WizardStep[] {
    return [
      WizardStep.WELCOME,
      WizardStep.CAMINHO_ENTRADA,
      WizardStep.IFOOD_PERGUNTA,
      WizardStep.CAMINHOS,
      WizardStep.BOAS_VINDAS,
      WizardStep.SUBDOMINIO,
      WizardStep.MODO_VENDA,
      WizardStep.PRODUTOS,
      WizardStep.TEMA,
      WizardStep.CONCLUSAO
    ];
  }

  obtenhaPassoAtual(state: WizardState): WizardStep {
    return state.passosAtivos[state.passoAtualIndex] || WizardStep.CAMINHO_ENTRADA;
  }

  podeAvancar(state: WizardState): boolean {
    return state.passoAtualIndex < state.passosAtivos.length - 1;
  }

  podeVoltar(state: WizardState): boolean {
    return state.passoAtualIndex > 0;
  }

  avance(state: WizardState): number {
    if (this.podeAvancar(state)) {
      return state.passoAtualIndex + 1;
    }
    return state.passoAtualIndex;
  }

  volte(state: WizardState): number {
    if (this.podeVoltar(state)) {
      return state.passoAtualIndex - 1;
    }
    return state.passoAtualIndex;
  }

  vaParaPasso(state: WizardState, step: WizardStep): number {
    const index = state.passosAtivos.indexOf(step);
    if (index >= 0 && index <= state.passoAtualIndex) {
      return index;
    }
    return state.passoAtualIndex;
  }

  vaParaPassoQualquer(state: WizardState, step: WizardStep): number {
    const index = state.passosAtivos.indexOf(step);
    return index >= 0 ? index : state.passoAtualIndex;
  }

  obtenhaProgresso(state: WizardState): number {
    if (state.passosAtivos.length <= 1) return 0;
    return Math.round((state.passoAtualIndex / (state.passosAtivos.length - 1)) * 100);
  }
}
